export const riskMatrix = {
  consequence: {
    label: "Consequence",
    save: "Save consequences",
  },
  probability: {
    label: "Probability",
    save: "Save probabilities",
  },
  riskLevel: {
    label: "Risk level",
    save: "Save risk levels",
  },
  value: {
    label: "Value",
  },
  noRisk: "none",
};
